module.exports = __webpack_public_path__ + "img/tile-rendering_cn.5641ce7.jpg";